import { FC } from 'react'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { Box, Typography, IconButton, Modal, useTheme } from '@mui/material'

import styles from './styles.module.scss'

interface IProps {
  sfaf: string
  isOpen: boolean
  handleChange: (sfaf: string) => void
  onClose: () => void
}

const SFAFView: FC<IProps> = ({ sfaf, isOpen, handleChange, onClose }) => {
  const theme = useTheme()

  return (
    <Modal className={styles.modal} open={isOpen} onClose={onClose}>
      <Box className={styles.modalContent}>
        <Box display="flex" flexDirection="column" height="100%">
          <Box className={styles.header}>
            <Typography
              data-testid="title"
              id="enableTitle"
              className={styles.title}
            >
              SFAF View
            </Typography>
            <IconButton data-testid="closeButton" onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Box>
          <textarea
            placeholder="SFAF value"
            onChange={(evt) => handleChange(evt.target.value)}
            style={{
              fontSize: 14,
              width: '100%',
              flexGrow: 1,
              padding: '5px',
              color: theme.palette.text.primary,
              backgroundColor: 'transparent',
            }}
            value={sfaf}
          />
        </Box>
      </Box>
    </Modal>
  )
}

export default SFAFView
